__turbopack_context__.v({
  "cellIcon": "DesktopComparison-module__IhUUVa__cellIcon",
  "cellIconCheck": "DesktopComparison-module__IhUUVa__cellIconCheck",
  "cellIconCross": "DesktopComparison-module__IhUUVa__cellIconCross",
  "cellText": "DesktopComparison-module__IhUUVa__cellText",
  "divider": "DesktopComparison-module__IhUUVa__divider",
  "group": "DesktopComparison-module__IhUUVa__group",
  "groupColumnHeader": "DesktopComparison-module__IhUUVa__groupColumnHeader",
  "groupColumnHeaderCol": "DesktopComparison-module__IhUUVa__groupColumnHeaderCol",
  "groupRows": "DesktopComparison-module__IhUUVa__groupRows",
  "groupSectionTitle": "DesktopComparison-module__IhUUVa__groupSectionTitle",
  "root": "DesktopComparison-module__IhUUVa__root",
  "row": "DesktopComparison-module__IhUUVa__row",
  "rowIntro": "DesktopComparison-module__IhUUVa__rowIntro",
  "rowLabel": "DesktopComparison-module__IhUUVa__rowLabel",
  "rowValue": "DesktopComparison-module__IhUUVa__rowValue",
});
